// extracted by mini-css-extract-plugin
module.exports = {"promoted":"AllegroVariantsTable_style_promoted__cg47Y","intyre":"AllegroVariantsTable_style_intyre__VaLNw"};